import React from 'react';
import { Typography } from '@mui/material';
import { StudioFlowColors } from '../studioFlowTheme';

export const FlowInputError: React.FC<{ message: string }> = ({ message }) => (
  <Typography
    sx={{
      color: '#D92D20',
      fontSize: 13,
      mt: 0.5,
      fontFamily: StudioFlowColors.bodyFontFamily,
    }}
  >
    {message}
  </Typography>
);
